import { occurrenceSchema, payOccurrenceBodySchema, type Occurrence } from '@klopotun/contracts';
import type { z } from 'zod';
import { apiRequest } from '../../../../shared/api/index.js';

/**
 * The body a caller writes, not the one the server ends up with: `applyAmountTo` carries a default,
 * and a payment with a variable amount is never asked the question it answers (design note C5a).
 * Taking the parsed type here would force every caller to answer it.
 */
export type PayOccurrencePayload = z.input<typeof payOccurrenceBodySchema>;

const postPay = (id: string, body: PayOccurrencePayload): Promise<unknown> =>
  apiRequest<unknown>(`/occurrences/${id}/pay`, { method: 'POST', body });

export const payOccurrence = async (id: string, body: PayOccurrencePayload): Promise<Occurrence> =>
  occurrenceSchema.parse(await postPay(id, body));
